import { cn } from "@/lib/utils";

// Dark glass card with a soft glowing border.
export const GlowCard = ({ className, children, ...props }) => {
  return (
    <div
      className={cn(
        "rounded-2xl border border-white/10 glass shadow-[0_0_0_1px_rgba(58,123,255,0.08),0_18px_60px_rgba(0,0,0,0.35)]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
};
